import React, { useEffect, useState } from 'react'
import CheckoutForm from '../CheckoutForm'
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { stripeAppearance } from '../paymentButtons.data';
import { connect, useSelector } from 'react-redux';
import { startProcessingPayment } from '../../../../redux/slices/cartSlice';
import { showErrorSnackbar } from '../../../../redux/slices/snackbarSlice';
import { useNavigate } from 'react-router-dom';
import routeConstant from '../../../../lib/constants/routeConstant';
import CommonLoader from '../../../shared/Loaders/CommonLoader/CommonLoader';

// loading client-secret
const STRIPE_CLIENT_SECRET = process.env.REACT_APP_STRIPE_CLIENT_SECRET;

const StripeElement = ({ orderId, startProcessingPayment, showErrorSnackbar, seasonId }) => {
  const navigate = useNavigate();

  const { checkoutApiData } = useSelector(state => state.cart)
  const [stripePromise, setStripePromise] = useState(null);
  const [clientSecret, setClientSecret] = useState(null);

  const startPaymentProcess = async () => {
    const data = { orderId }

    await startProcessingPayment(data);
  }
  
  useEffect(() => {
    const fetchStripe = async () => {
      try {
        const stripeInstance = await loadStripe(STRIPE_CLIENT_SECRET);
        setStripePromise(stripeInstance);
      } catch (error) {
        navigate(routeConstant.CART_PAGE);
        // Show Error
        setTimeout(() => {
          showErrorSnackbar({ title: "Payment Failed, Please refresh and try again." })
        }, 0)
        console.log("Stripe Loading Error", error);
      }
    };
    fetchStripe();
  }, []);


  // Check if paymentMethodType is STRIPE if not return null
  // if(paymentButonResponse?.paymentMethodType !== PAYMENT_METHOD_TYPE.STRIPE) return null // only proceed if paymentMethodType is STRIPE

  useEffect(() => {
    const _clientSecret = checkoutApiData?.paymentResponseBody?.client_secret; // fetch client-secret
    setClientSecret(_clientSecret);
  }, [checkoutApiData?.paymentResponseBody]);
  
  const stripeConfig = {
    options: {
      clientSecret,  // client-secret
      appearance: stripeAppearance, // stripe-appearance-style
      loader: "auto",
    },
    stripe: stripePromise,
  };

  if(!stripePromise || !clientSecret) {
    return <CommonLoader />
  }
  
  return (
    <Elements {...stripeConfig}>
      <CheckoutForm startPaymentProcess={startPaymentProcess} return_url={`${window.location.href}?orderId=${orderId}&seasonId=${seasonId}`} /> {/* Checkckout Form */}
    </Elements>
  );
};

const mapDispatchToProps = dispatch => ({
  startProcessingPayment: (data) => dispatch(startProcessingPayment(data)),
  showErrorSnackbar: (data) => dispatch(showErrorSnackbar(data)),
});

export default connect(null, mapDispatchToProps)(StripeElement);